/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./OrgForgotPasswordConfirm.css";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

class OrgForgotPasswordConfirm extends Component {
  componentDidMount() {
    try {
      if (
        this.props.location.confirm !== null ||
        this.props.location.confirm !== undefined
      ) {
        if (!this.props.location.confirm) {
          this.props.history.push({
            pathname: "/OrgForgotPassword",
          });
        }
      }
    } catch (e) {
      this.props.history.push({
        pathname: "/OrgForgotPassword",
      });
    }
  }
  render() {
    const languageObj = this.props.languageObj;
    return (
      <div className="OrgForgotPasswordConfirm-view">
        <div className="OrgForgotPasswordConfirm-prompt">
          <div className="OrgForgotPasswordConfirm-loginContainer">
            <div className="OrgForgotPasswordConfirm-CheckPlusLogo" />

            <div className="OrgForgotPasswordConfirm-heading">
              {languageObj.heading}
            </div>

            <div className="OrgForgotPasswordConfirm-descriptionGroup">
              <div className="OrgForgotPasswordConfirm-mailboxIcn" />
              <div className="OrgForgotPasswordConfirm-description">
                {languageObj.text}
              </div>
            </div>
            <Link to={"/" + this.props.language}>
              <div className="OrgForgotPasswordConfirm-doneBtn">
                {languageObj.doneBtn}
              </div>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

OrgForgotPasswordConfirm.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
};

export default OrgForgotPasswordConfirm;
